module.exports = __webpack_public_path__ + "img/COMBO FLOWER BW.525a78a.svg";